<template>
  <div>
    <el-table
      :data="packTypes"
    >
      <el-table-column
        prop="pack_type"
        label="Típus"
        show-overflow-tooltip
        width="120"
      >
        <template slot-scope="scope">
          {{ scope.row.pack_type.name }}
        </template>
      </el-table-column>
      <el-table-column
        prop="count_per_pack"
        label="Darab/Kiszerelés"
        show-overflow-tooltip
        width="180"
      />
      <el-table-column
        prop="count_per_row"
        label="Kiszerelés/Sor"
        show-overflow-tooltip
        width="160"
      />
      <el-table-column
        prop="count_per_pack"
        label="Webshopban elérhető"
        width="180"
      >
        <template slot-scope="scope">
          <el-tag
            v-if="scope.row.available_in_webshop"
            size="small"
            type="success"
          >
            Igen
          </el-tag>
          <el-tag
            v-if="!scope.row.available_in_webshop"
            size="small"
            type="danger"
          >
            Nem
          </el-tag>
        </template>
      </el-table-column>
      <el-table-column
        label="Netto súly"
        prop="weight"
        width="130"
      >
        <template slot-scope="scope">
          {{ scope.row.weight|localized_numeric }} kg
        </template>
      </el-table-column>
      <el-table-column
        label="Brutto súly"
        prop="gross_weight"
        width="130"
      >
        <template slot-scope="scope">
          {{ scope.row.gross_weight|localized_numeric }} kg
        </template>
      </el-table-column>
      <el-table-column
        label="Magasság"
        prop="gross_weight"
        width="130"
      >
        <template slot-scope="scope">
          {{ scope.row.height|localized_numeric }} mm
        </template>
      </el-table-column>
      <el-table-column
        label="Szélesség"
        prop="gross_weight"
        width="130"
      >
        <template slot-scope="scope">
          {{ scope.row.width|localized_numeric }} mm
        </template>
      </el-table-column>
      <el-table-column
        label="Hosszúság"
        prop="length"
        width="130"
      >
        <template slot-scope="scope">
          {{ scope.row.length|localized_numeric }} mm
        </template>
      </el-table-column>
      <el-table-column
        fixed="right"
        label=""
        width="130"
        style="text-align: right;"
      >
        <template
          slot-scope="scope"
        >
          <actions
            :packType="scope.row"
            @update="onUpdate"
            @delete="onDelete"
          />
        </template>
      </el-table-column>
    </el-table>
    <el-dialog
      :visible="showDialog"
      :title="packTypeFormType === 'add' ? 'Új kiszerelés' : 'Kiszerelés módosítás'"
      append-to-body
      :close-on-click-modal="false"
      width="550px"
      @close="onClose"
    >
      <pack-type-form
        v-if="showDialog"
        ref="packTypeForm"
        :defaultPackType="selectedPackType"
        :formType="packTypeFormType"
      />
      <div
        slot="footer"
        class="dialog-footer"
      >
        <el-button @click="onClose">
          Mégse
        </el-button>
        <el-button
          type="primary"
          @click="storePackTypes"
        >
          {{ packTypeFormType === 'add' ? 'Hozzáadás' : 'Módosítás' }}
        </el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import Actions from './Actions';
import PackTypeForm from './Form';

export default {
  components: { Actions, PackTypeForm },
  props: ['packTypes', 'showDialog', 'packTypeFormType'],
  data() {
    return {
      selectedPackType: {},
    };
  },
  methods: {
    onClose() {
      this.$emit('closeDialog');
    },
    onUpdate(packType) {
      this.selectedPackType = Object.assign({}, packType);
      this.$emit('openUpdateDialog');
    },
    onDelete(packType) {
      const packTypes = this.packTypes.filter(a => ((a.id && a.id !== packType.id) || a.key !== packType.key));
      this.$emit('change', packTypes);
    },
    async storePackTypes() {
      const packType = Object.assign({}, this.$refs.packTypeForm.packType);
      this.$refs['packTypeForm'].$refs['packTypeForm'].validate(valid => {
        if (valid) {
          packType.ean_codes = this.$refs['packTypeForm'].$refs['eanItems'].getItems();
          if (this.packTypeFormType === 'add') {
            this.$emit('add', packType);
          } else {
            const packTypes = this.packTypes.map(a => {
              if ((a.id && a.id === packType.id) || (a.key && a.key === packType.key)) {
                return packType;
              } else {
                return a;
              }
            });
            this.$emit('change', packTypes);
          }
          this.$emit('closeDialog');
        }
      });
    },
  }
};
</script>
